import Phaser from 'phaser'
import Player from '../characters/player'
import SettingsMenu from '../classes/SettingsMenu'



export default class Tutorial1 extends Phaser.Scene
{

    private camera!: Phaser.Cameras.Scene2D.Camera;
    private player!: Player;
    private groundLayer!: Phaser.Tilemaps.TilemapLayer;
    private resetKey!: Phaser.Input.Keyboard.Key;
    private spikeGroup!: Phaser.Physics.Arcade.StaticGroup;
    private isPlayerDead!: boolean;
    private endPoint!: Phaser.Types.Tilemaps.TiledObject;
    private settingsMenu!: SettingsMenu;


	constructor()
	{
    super('tutorial_1')
	}
	preload()
  {
  }

  create()
  {
    this.isPlayerDead = false;
    const map = this.make.tilemap({ key: "tutorial_map_1" });
    const tiles = map.addTilesetImage("0x72-industrial-tileset-32px-extruded", "tiles");
    if (!tiles) {
      throw new Error('Missing tileset: 0x72-industrial-tileset-32px-extruded')
    }

    map.createLayer("Background", tiles);
    const groundLayer = map.createLayer("Ground", tiles);
    if (!groundLayer) {
      throw new Error('Missing Ground layer in tutorial_map_1')
    }
    this.groundLayer = groundLayer
    map.createLayer("Foreground", tiles);

    // Put tile index 1 at tile grid location (20, 10) within layer
    this.groundLayer.putTileAt(1, 20, 10);

    // Put tile index 2 at world pixel location (200, 50) within layer
    // (This uses the main camera's coordinate system by default)
    this.groundLayer.putTileAtWorldXY(2, 200, 50);

    const spawnPoint = map.findObject(
      "Objects",
      obj => obj.name === "Spawn Point"
    );
    if (!spawnPoint || typeof spawnPoint.x !== 'number' || typeof spawnPoint.y !== 'number') {
      throw new Error('Spawn Point object is missing or invalid in tutorial_map_1')
    }
    
    const endPoint = map.findObject(
      "Objects",
      obj => obj.name === "End Point"
    );
    if (!endPoint || typeof endPoint.x !== 'number' || typeof endPoint.y !== 'number') {
      throw new Error('End Point object is missing or invalid in tutorial_map_1')
    }
    this.endPoint = endPoint
      // console.log(this.endPoint)


    this.player = new Player(this, spawnPoint.x, spawnPoint.y);
    const playerSprite = this.player.getSprite()

    this.groundLayer.setCollisionByProperty({ collides: true });
    this.physics.world.addCollider(playerSprite, this.groundLayer);

    // The map contains a row of spikes. The spike only take a small sliver of the tile graphic, so
    // if we let arcade physics treat the spikes as colliding, the player will collide while the
    // sprite is hovering over the spikes. We'll remove the spike tiles and turn them into sprites
    // so that we give them a more fitting hitbox.
    this.spikeGroup = this.physics.add.staticGroup();
    this.groundLayer.forEachTile((tile) => {
      if (tile.index === 77) {
        const spike = this.spikeGroup.create(
          tile.getCenterX(),
          tile.getCenterY(),
          "spike"
        );

        // The map has spikes rotated in Tiled (z key), so parse out that angle to the correct body
        // placement
        spike.rotation = tile.rotation;
        if (spike.angle === 0) spike.body.setSize(32, 6).setOffset(0, 26);
        else if (spike.angle === -90)
          spike.body.setSize(6, 32).setOffset(26, 0);
        else if (spike.angle === 90) spike.body.setSize(6, 32).setOffset(0, 0);

        this.groundLayer.removeTileAt(tile.x, tile.y);
      }
    });


    if (!this.input.keyboard) {
      throw new Error('Keyboard input is not available in this scene')
    }
    this.resetKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.R)

    this.add
    .text(16, 16, "Arrow/WASD to move\n Space to jump", {
      font: "18px monospace",
      color: "#000000",
      padding: { x: 20, y: 10 },
      backgroundColor: "#ffffff",
    })
    .setScrollFactor(0);

    this.settingsMenu = new SettingsMenu(this, { pauseGameplay: true })

    // debugDraw(this.groundLayer, this)

    this.initCamera(map)
  }

  private initCamera(map: Phaser.Tilemaps.Tilemap): void {
    this.camera = this.cameras.main;
    this.cameras.main.startFollow(this.player.getSprite());
    this.camera.setBounds(0, 0, map.widthInPixels, map.heightInPixels);

  }

  update(t: number, d: number)
  {

    if (this.isPlayerDead) return;
    if (this.settingsMenu.isOpen()) return;

    this.player.update();
    // console.log(this.player.sprite)


    if (
      Phaser.Input.Keyboard.JustDown(this.resetKey) ||
      this.player.getSprite().y > this.groundLayer.height ||
      this.physics.world.overlap(this.player.getSprite(), this.spikeGroup)
    ) 
    {
      // Flag that the player is dead so that we can stop update from running in the future
      this.isPlayerDead = true;

      this.camera.shake(100, 0.05);
      this.camera.fade(250, 0, 0, 0);

      // Freeze the player to leave them on screen while fading but remove the marker immediately
      this.player.freeze();

      this.camera.once("camerafadeoutcomplete", () => {
        this.player.destroy();
        this.scene.restart();
      });
    }

    if (
      Math.abs(this.player.getSprite().y - Math.round(this.endPoint.y ?? 0)) <= 10
      &&
      Math.abs(this.player.getSprite().x - Math.round(this.endPoint.x ?? 0)) <= 10
    )
    {
      this.scene.start('tutorial_2')
      // console.log('end level')
    }
    // console.log(this.player.sprite.y)
    // console.log(Math.round(this.endPoint.y) )
    // console.log(Math.abs(this.player.sprite.y - Math.round(this.endPoint.y)))
    // console.log(" ")
  }
}
